<div *transloco="let t">
  <app-dialog-title>
    @if (!isProductionMode) {
    <span
      >{{ isCreate ? t("settings.add") : t("settings.update") }}
      {{ smartFormAlias }} {{ "settings.type" | transloco }}</span
    >
    } @if (!isProductionMode) {
    <span class="yearSelected">(Year {{ configYear }})</span>
    }
  </app-dialog-title>

  <mat-dialog-content>
    <div class="content">
      <form [formGroup]="form" class="ui form">
        <div class="field">
          <label>{{ "settings.name" | transloco }}:</label>
          <input formControlName="name" class="form-control" />
        </div>
        <div class="field">
          <label>{{ "settings.description" | transloco }}:</label>
          <input formControlName="description" class="form-control" />
        </div>
        <div class="field" [ngClass]="{ disabled: smartFormType?.lock }">
          @if (taxReturnTypeList) {
          <app-search-dropdown
            label="Tax Return Type"
            [formCtrl]="taxReturnTypeName"
            [listOptions]="taxReturnTypeList"
          ></app-search-dropdown>
          }
        </div>
        <div class="field" [ngClass]="{ disabled: smartFormType?.lock }">
          <label class="checkbox-label"
            >Exportable:
            <input
              class="checkbox-input"
              type="checkbox"
              formControlName="exportable"
          /></label>
        </div>
        <div
          class="field"
          [ngClass]="{ disabled: smartFormHasQuestions || smartFormType?.lock }"
        >
          @if (taxReturnTypeList) {
          <app-search-dropdown
            [label]="'settings.source' | transloco"
            [formCtrl]="source"
            [listOptions]="sourceListOptions"
          ></app-search-dropdown>
          }
        </div>
        @if (exportable.value) {
        <div class="field" [ngClass]="{ disabled: smartFormType }">
          <label class="checkbox-label"
            >{{ "settings.Wait-for-all-smartforms-in-batch" | transloco }}:
            <input
              type="checkbox"
              formControlName="waitForAllSmartFormsInBatch"
              class="checkbox-input"
          /></label>
        </div>
        }
      </form>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <a class="go-back cancel" (click)="onClose()">{{
      "settings.cancel" | transloco
    }}</a>
    @if (!isProductionMode) {
    <button
      [disabled]="form.invalid"
      (click)="saveSmartFormType()"
      class="ui primary button"
    >
      {{ isCreate ? t("settings.add") : t("settings.update") }}
      {{ smartFormAlias }} {{ "settings.type" | transloco }}
    </button>
    }
  </mat-dialog-actions>
</div>
